module.exports = __webpack_public_path__ + "static/media/Logo.49d1563b.png";